import { type } from "os";

export interface User {
  id: string;
  name: string;
  user_name: string;
  email: string;
}

// Create a schema representation of the interface
export const UserSchema = {
  name: 'User',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    user_name: { type: 'string' },
    email: { type: 'string' }
  }
};
